var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalories(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.184 9.65196C16.7191 8.33051 16.0416 7.10663 15.1823 6.03589C13.695 4.19129 11.4 3 9.6 3C10.3125 5.8125 9.0615 7.70571 7.92038 9.58004C6.975 11.1305 6 12.7341 6 14.5714C6 18.116 8.69175 21 12 21C15.3083 21 18 18.116 18 14.5714C18 12.8317 17.7255 11.1767 17.184 9.65196ZM13.2124 18.5367C12.825 18.9786 12.3394 19.0714 12 19.0714C11.6606 19.0714 11.175 18.9786 10.7876 18.5367C10.4002 18.0947 10.2 17.3936 10.2 16.5C10.2 15.4899 10.5307 14.7209 10.8502 13.9776C11.0932 13.4123 11.4 12.8839 11.4169 12.19C11.8406 12.4263 12.3045 12.8695 12.7121 13.4468C13.3935 14.4111 13.7996 15.553 13.7996 16.5004C13.8 17.3936 13.5967 18.0979 13.2124 18.5367Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalories);
export default __webpack_public_path__ + "static/media/Calories.4163e2517235c790e42b766552cc7c27.svg";
export { ForwardRef as ReactComponent };